import React from 'react';
import { Icon } from '@web-chat-core/ui-kit';

export const DropdownIndicatorComponent = React.memo(() => <Icon icon="icSelectDown" />);
